/**
 * Copia o texto e diz se deu certo. Tenta a área de transferência do navegador e, sem ela (página
 * fora de HTTPS, navegador antigo ou permissão negada), o `execCommand('copy')`.
 */
export const copiarTexto = async (texto) => {
    if (!texto) return false;

    try {
        if (navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(texto);
            return true;
        }
    } catch {
        // segue para o jeito antigo
    }

    try {
        const campo = document.createElement('textarea');
        campo.value = texto;
        campo.setAttribute('readonly', '');
        campo.style.position = 'fixed';
        campo.style.opacity = '0';
        document.body.appendChild(campo);
        campo.select();
        const copiou = typeof document.execCommand === 'function' && document.execCommand('copy');
        document.body.removeChild(campo);
        return Boolean(copiou);
    } catch {
        return false;
    }
};
